import React, {useEffect, useState} from 'react'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import clsx from 'clsx'
import {
  createCategories,
  getAllCategories,
  removeCategories,
  updateCategories,
  updateCategoriesOrder,
} from '../../../../../../API/api-endpoint'
import ToastUtils from '../../../../../../utils/ToastUtils'
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd'
import SubCategoryPlugins from './SubCategoriesPlugin'

const CategoriesPlugin = () => {
  const [categoryList, setCategoryList] = useState<any>([])
  const [category, setCategory] = useState('')
  const [categoryFlag, setCategoryFlag] = useState(1)
  const [categoryID, setCategoryID] = useState(0)

  useEffect(() => {
    getAllCategoryList()
  }, [categoryFlag])

  const getAllCategoryList = async () => {
    let result = await getAllCategories()
    setCategoryList(result.data)
  }

  const addCategoryInList = async () => {
    let result = await createCategories(category, categoryList.length + 1)

    if (result.success) {
      setCategoryFlag(categoryFlag + 1)
      setCategory('')
      ToastUtils({type: 'success', message: 'Category Was Added'})
    } else {
      ToastUtils({type: 'error', message: 'Category Was Not Added'})
    }
  }

  //   const deleteCategoryInList = async () => {
  //     let result = await removeCategories(categoryID)
  //     if (result.status === 200) {
  //       setCategoryFlag(categoryFlag + 1)
  //       setCategory('')
  //       ToastUtils({type: 'success', message: 'Interest Was Deleted'})
  //     } else {
  //       ToastUtils({type: 'error', message: 'Interest Was Not Deleted'})
  //     }
  //   }

  const updateCategoryInList = async () => {
    let result = await updateCategories(categoryID, category)

    if (result.success) {
      setCategoryFlag(categoryFlag + 1)
      setCategory('')
      setCategoryID(0)
      ToastUtils({type: 'success', message: 'Category Was Updated'})
    } else {
      ToastUtils({type: 'success', message: 'Category Was Not Updated'})
    }
  }

  const updateCategoryOrderInList = async () => {
    let result = await updateCategoriesOrder(categoryList)
    if (result.success) {
      setCategoryFlag(categoryFlag + 1)
      setCategory('')
      setCategoryID(0)
      ToastUtils({type: 'success', message: 'Category Was Updated'})
    } else {
      ToastUtils({type: 'success', message: 'Category Was Not Updated'})
    }
  }

  // Handle Drag End
  const handleDragEnd = (result: any) => {
    if (!result.destination) return

    const newCategories = [...categoryList]
    const [movedItem] = newCategories.splice(result.source.index, 1)
    newCategories.splice(result.destination.index, 0, movedItem)

    const updatedCategories = newCategories.map((item, index) => ({
      ...item,
      order: index + 1,
    }))

    setCategoryList(updatedCategories)
  }

  return (
    <KTCardBody className='py-4 '>
      <div className='mt-4 '>
        <div className='d-flex justify-content-end'>
          <button className='btn btn-sm btn-primary me-2' onClick={updateCategoryOrderInList}>
            Update Category Order
          </button>
          <button
            className='btn btn-sm btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            Add Category
          </button>
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId='interests' direction='horizontal'>
            {(provided) => (
              <div
                className='mt-5 d-flex flex-wrap'
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {categoryList.map((category, index) => (
                  <Draggable key={category._id} draggableId={category._id} index={index}>
                    {(provided) => (
                      <div
                        className='badge badge-dark text-center me-3 mb-5 fs-6 fw-bold'
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_2'
                        onClick={() => {
                          setCategory(category?.name)
                          setCategoryID(category?.category_id)
                        }}
                      >
                        {category?.name}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Add Category</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='fa-solid fa-xmark'></i>
              </div>
            </div>
            <div className='modal-body'>
              <input
                placeholder='Enter Your Category'
                type='text'
                name='category'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                Close
              </button>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={addCategoryInList}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Edit Category</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='fa-solid fa-xmark'></i>
              </div>
            </div>
            <div className='modal-body'>
              <input
                placeholder='Enter Your Category'
                type='text'
                name='category'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </div>
            <div className='modal-footer'>
              {/* <button
                type='button'
                className='btn btn-danger'
                data-bs-dismiss='modal'
                onClick={deleteCategoryInList}
              >
                Delete Category
              </button> */}
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={updateCategoryInList}
              >
                Update Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <SubCategoryPlugins />
      </div>
    </KTCardBody>
  )
}

export default CategoriesPlugin
